export const MessageFormatter = {
  CampaignItem: '{{selectedCustomerId}}',
};

export const Messages = {
  SUCCESS: "Success",
  ERROR: "Error",
  CONFIRMATION_TITLE: 'Delete',
  CONFIRMATION_MESSAGE: 'Are you sure you want to delete the selected message?',
  MESSAGE_SUCCESS: 'Message sent successfully.',
  MSG_DELETE_SUCCESS: 'Message deleted successfully.',
  MAX_FILE_SIZE_ERROR: 'Max file size 5MB',
  INVALID_QUICK_ORDER_FILE_FORMAT: 'The supported file format is csv.',
  INVALID_REBATE_FILE_FORMAT: 'Invalid file type. Please try again.',
  INVALID_FIELD_VALUE: ' All Fields Required',
  INVALID_USER_FORGOT_PASSWORD: 'The userId you entered is incorrect for the website.',
  NO_RESULTS_FOUND: 'No results found',
  CAMPAIGNID_ALREADY_EXIST: 'Campaign already exists for the Customer',
  NO_RECORDS_UPDATED: "No records updated. Invalid data format, please update the file & try again.",
  ACCOUNT_ASSOCIATE: 'Account Associated successfully.',
  USER_ROLE_SAVED: 'User Role Successfully Saved.',
  USER_ROLE_VALIDATION: 'The Purchaser or Shopper role is required. ',
  POPUP_SAVED: 'Change Successfully Saved.',
  PRIMARY_USER_SAVE: 'Primary user saved successfully',
  PRIMARY_USER_REMOVE: 'The user being modified is a Primary User associated to one or more accounts. Please remove the primary user association(s) before proceeding.',
  PRIMARY_USER_ASSOCIATION: 'Primary User Association',
  GENERAL_API_ERROR: 'Something went wrong on our end. Please refresh your browser and try again. If the problem persists, please contact our customer service department at 888.527-6806.',
  USER_NOT_LOCKED: 'Your account is not Locked. Please try the forgot password',
  EMAIL_SENT: 'Email sent successfully!',
  USER_NOT_FOUND: 'The username you entered does not match any in our records.',
  USER_ALREADY_ACTIVE: 'Activation failed because the user is already active.',
  RBC_FIELD_SAVED: 'Fields saved.',
  RBC_FILE_UPLOAD: 'File uploaded successfully',
  ORDER_SUBMISSION_SUCCESS_MSG: 'Order Submission started successfully',
  SELECT_REQUIRED_FIELD: 'Please Select Start Date and End Date.',
  MAINTENANCE_SUCESS_ADDED: 'Maintenance Sucessfully Added/Updated.',
  MAINTENANCE_DELETED: 'Maintenance Sucessfully Deleted.',
  PROGRAM_ADD_UPDATE_SUCCESS: 'Program(s) Sucessfully Added/Updated.',
  CI_ADD_UPDATE_SUCCESS: 'Campaign Items(s) Sucessfully Added/Updated.',
  CC_ADD_UPDATE_SUCCESS: 'Campaign Customer(s) Sucessfully Added/Updated.',
  PROGRAM_FOR_ALL_ACCOUNT: 'Campaign item- '+ MessageFormatter.CampaignItem +' applicable for all customers.',
  VISIBILITY_OF_SPD_ITEMS_SUCCESS: 'SPD Item(s) Successfully Updated.',
  USER_TYPE_UPDATED_SUCSESS: 'User Resource Type Sucessfully Updated.',
  EMPTY_FILE_UPLOAD: 'Uploded file is empty.',
}


export const MessagesType = {
  MSG_TYPE_INBOX: "1005",
  MSG_TYPE_BROADCAST: "1004"
}

export const MessageDropDownData = {
  messageType: [
    {
      label: 'Select Message Type',
      value: ""
    },
    {
      label: 'Broadcast',
      value: '1004'
    },
    {
      label: 'Inbox',
      value: '1005'
    }
  ],
  emailTos: [
    {
      label: 'Select a Department',
      value: ""
    },
    {
      label: 'Accounts Receivable',
      value: 'Accounts Receivable'
    },
    {
      label: 'Customer Service',
      value: 'Customer Service'
    },
    {
      label: 'Generics',
      value: 'Generics'
    },
    {
      label: 'Marketing',
      value: 'Marketing'
    },
    {
      label: 'Sales',
      value: 'Sales'
    },
    {
      label: 'Technical Support',
      value: 'Technical Support'
    }
  ],
  states: [
    {
      label: 'Select a State',
      value: ""
    },
    {
      label: 'CT',
      value: 'CT'
    },
    {
      label: 'DE',
      value: 'DE'
    },
    {
      label: 'MA',
      value: 'MA'
    },
    {
      label: 'ME',
      value: 'ME'
    },
    {
      label: 'NJ',
      value: 'NJ'
    },
    {
      label: 'NY',
      value: 'NY'
    },
    {
      label: 'PA',
      value: 'PA'
    },
    {
      label: 'RI',
      value: 'RI'
    }
  ]
}
